import { render, staticRenderFns } from "./Comprar.vue?vue&type=template&id=1f3d1288&"
import script from "./Comprar.vue?vue&type=script&lang=js&"
export * from "./Comprar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports